// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsChat-ChatForm-chatSettings-ChatSettingsMenu-module__form--QNPZD {
  display: grid;
  row-gap: 10px;
}
.src-businessServices-services-bsChat-ChatForm-chatSettings-ChatSettingsMenu-module__header--EabyD {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsChat/ChatForm/chatSettings/ChatSettingsMenu.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;AACF;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAAF","sourcesContent":[".form {\n  display: grid;\n  row-gap: 10px;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `src-businessServices-services-bsChat-ChatForm-chatSettings-ChatSettingsMenu-module__form--QNPZD`,
	"header": `src-businessServices-services-bsChat-ChatForm-chatSettings-ChatSettingsMenu-module__header--EabyD`
};
export default ___CSS_LOADER_EXPORT___;
